<!-- START Sidebar (left)-->
<div class="aside-inner">
  <nav class="sidebar" sidebar-anyclick-close="">
    <!-- START sidebar nav-->
    <ul class="sidebar-nav" style="height: 100%; display: flex; flex-direction: column">
      <li
        *ngFor="let item of menuItems"
        [ngClass]="{ 'nav-heading': item.heading }"
        [routerLinkActive]="['active']"
        [ngStyle]="item.position === 'bottom' ? { 'margin-top': 'auto' } : {}"
      >
        <!-- menu heading -->
        <span *ngIf="item.heading">{{ item.text }}</span>
        <!-- external links -->
        <a
          href
          *ngIf="!item.heading && !item.submenu && item.elink"
          [routerLink]="item.link"
          [attr.route]="item.link"
          [title]="!!item.longText ? item.longText : item.text"
        >
          <span
            class="float-right"
            *ngIf="item.alert"
            [ngClass]="item.label || 'badge badge-success'"
            >{{ item.alert }}</span
          >
          <em *ngIf="item.icon">
            <fa-icon [icon]="item.icon"></fa-icon>
          </em>
          <span>{{ item.text }}</span>
        </a>
        <!-- single menu item link-->
        <a
          href
          *ngIf="!item.heading && !item.submenu && !item.elink && item.link"
          [routerLink]="item.link"
          [attr.route]="item.link"
          [title]="!!item.longText ? item.longText : item.text"
        >
          <em *ngIf="item.icon">
            <fa-icon [icon]="item.icon"></fa-icon>
          </em>
          <span [innerHTML]="item.text"></span>
        </a>
        <!-- single menu item function-->
        <a
          href
          *ngIf="!item.heading && !item.submenu && !item.elink && !!item.func"
          [title]="!!item.longText ? item.longText : item.text"
          (click)="calledAction($event, item.func)"
        >
          <em *ngIf="item.icon">
            <fa-icon [icon]="item.icon"></fa-icon>
          </em>
          <span [innerHTML]="item.text"></span>
        </a>
      </li>
    </ul>
    <!-- END sidebar nav-->
  </nav>
</div>
<!-- END Sidebar (left)-->
